/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 32,
  image: "default-changelog-v2.png",
  title: "FVM Payments, IPFS Migration, Site SDK, Storage & Browser-Upload Improvements, Platform Fixes",
  shortDescription: "We have added support for Filecoin Virtual Machine payments. Migrated the IPFS nodes to bare metal servers which will enhance scalability. Published a new Site SDK with support for working with Web App organizations. Added CID pinning support on Storage SDK. Fixed a couple of issues on the Spheron app.",
  description: "We have added support for Filecoin Virtual Machine payments. Migrated the IPFS nodes to bare metal servers which will enhance scalability. Published a new Site SDK with support for working with Web App organizations. Added CID pinning support on Storage SDK. Fixed a couple of issues on the Spheron app.",
  date: "June 2nd, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Storage", "SDK", "Browser-Upload", "FVM"]
};
export const content = `

## Introducing Filecoin Virtual Machine (FVM) for Payments

- Introduced Filecoin Virtual Machine (FVM) Chain for easy and secure payments on Spheron.
- Enabled FIL token within the FVM ecosystem to enhance transaction flexibility.
- Upgrade process to PRO plan remains unchanged, using Metamask wallet and selecting the Filecoin option.
- Users can proceed to upgrade to the subscription pro plan and purchase bonuses.

## IPFS Migration

- Migrated our IPFS nodes on bare metal servers (using kubernetes for service orchestration).
- This migration enables enhanced scalability, offering the flexibility to accommodate increased workloads effortlessly. By leveraging cost-effective storage solutions, it optimizes resource allocation, thereby optimizing cost efficiency. Furthermore, the migration facilitates an expanded bandwidth capacity, allowing for seamless data transfer and improved network performance.

## [Site SDK](https://www.npmjs.com/package/@spheron/site)

- Introducing [@spheron/site](https://www.npmjs.com/package/@spheron/site) package which supports working with Spheron Web-App organizations directly from your application.
- Functionality includes deploying and redeploying projects, checking deployment logs, attaching domains, viewing organization usage statistics, and much more.
- Refer to the README in [@spheron/site](https://www.npmjs.com/package/@spheron/site) or the [documentations](https://docs.spheron.network/sdk/site/) for more information.

## [Storage SDK](https://www.npmjs.com/package/@spheron/storage)

- We have published a new version of the [@spheron/storage](https://www.npmjs.com/package/@spheron/storage) with the following updated:
- **New Pin CID Logic**: We've added a new function _pinCID_ which can be used to pin the CID to Spheron IPFS nodes.
- **Pin Status Verification**: We’ve added a new function _getCIDStatus_ which can be used to check the pin status of any CID on Spheron IPFS Nodes.
- Added CID to the return value of the upload function.
- Refer to the [documentations](https://docs.spheron.network/sdk/storage/) for more information.

## [Browser-Upload SDK](https://www.npmjs.com/package/@spheron/browser-upload)

- We have added the uploaded data's CID to the _upload_ function's return values in [@spheron/browser-upload](https://www.npmjs.com/package/@spheron/browser-upload).

## Platform Fixes

- **IPFS Gateways**: Fixed missing CORS headers in the responses.
- **Update Instance Bug**: Fixed bug related to updating instances with a port different from port 80.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
